module.exports = __webpack_public_path__ + "static/img/parkson.4ee0c6e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/solution/case/parkson.png
// module id = qYGR
// module chunks = 34